import React, {useEffect, useMemo} from 'react'
import {Box, Container, Flex, Stack, Text} from '../../vanilla'
import {observer} from 'mobx-react'
import {Seo} from '../../components/seo'
import {Breadcrumbs} from '../../components/breadcrumbs'
import {Layout} from '../../components/layout'
import {TObservablePage} from '../../types/commerce'
import {Link} from '../../components/link'
import {useCategoryStore, useContentStore} from '../../store/hooks/useStore'
import {sitemapLinkContainer} from './styles.css'
import {usePageDataTracking} from '../../analytics/page-tracking'

const Sitemap: TObservablePage = observer(() => {
  const {routeMap} = useContentStore()
  const {categories, fetchAllCategories, status} = useCategoryStore()

  useEffect(() => {
    const getCategories = async () => {
      if (status === 'idle' && (!categories || Object.keys(categories).length === 0)) {
        await fetchAllCategories()
      }
    }
    getCategories()
  }, [status, fetchAllCategories, categories])

  const siteMapLinks = useMemo(() => {
    if (!Object.keys(categories).length) return []

    const links: {path: string; id: string; name: string}[] = []

    for (const categoryId in categories) {
      for (const categoryRoute in routeMap) {
        if (routeMap[categoryRoute]) {
          const [_, contentType, contentId] = routeMap[categoryRoute].split('|')
          if (
            contentType === 'CATEGORY' &&
            contentId === categoryId &&
            categories[categoryId]?.name
          ) {
            links.push({
              id: categoryId,
              path: categoryRoute,
              name: categories[categoryId].name || '',
            })
          }
        }
      }
    }

    return links.sort((prev, next) => prev.name.localeCompare(next.name))
  }, [categories, routeMap])

  const sendPageData = usePageDataTracking()
  const pageType = 'sitemap'
  const pageCategory = 'Site Map'

  useEffect(() => {
    sendPageData(pageType, pageCategory)
  }, []);

  return (
    <Layout>
      <Container
        flexDirection="column"
        display="flex"
        gap="28px"
        paddingY="16px"
        marginBottom="48px"
        paddingX={['16px', '16px', '0px']}
      >
        <Seo title="Sitemap | Iceland Foods" />
        <Breadcrumbs display={['none', 'block']} breadcrumbs={[{id: 'SITEMAP', name: 'Sitemap'}]} />
        <Box>
          <Text variant="heading5">Sitemap</Text>
        </Box>
        <Stack
          direction={['column', 'row']}
          flexWrap="wrap"
          width="full"
          align="stretch"
          spacing={['16px', '20px']}
        >
          {siteMapLinks.map((link) => (
            <Flex
              key={link.id}
              className={sitemapLinkContainer}
              bg="white"
              padding="16px"
              borderRadius="base"
              border="1px"
              borderColor="gray200"
              align="center"
              justify={['flex-start', 'center']}
            >
              <Text
                as={Link}
                to={link.path}
                align={['left', 'center']}
                color="inherit"
                variant="unstyled"
                fontWeight="medium"
                fontSize={['lg', 'xl']}
                lineHeight="none"
                cursor="pointer"
              >
                {link.name}
              </Text>
            </Flex>
          ))}
        </Stack>
      </Container>
    </Layout>
  )
})

export default Sitemap